<template>
    <div>
        <p class="font-bold mt-3 text-lg" style="margin-left: 20px">My Programs</p>
        <el-table :data="dataList" style="max-width: 1360px;font-size: 12px;padding: 20px;box-sizing: border-box;overflow-x: auto;"
            empty-text="No Data" :highlight-current-row="false" :highlight-selection-row="false"
            :header-cell-class-name="'custom-head-cell'" :cell-style="tableCellstyle" :row-class-name="'custom-row-bg'">
            <el-table-column prop="project.project_ename" label="Program">
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center; justify-content: center;font-size: 14px;">
                        <span 
                            @click="goToProjectDetail(scope.row.project)" 
                            style="cursor: pointer; color: #409EFF;">
                            {{ scope.row.project.project_ename }}
                        </span>
                        <i 
                            class="el-icon-info" 
                            style="margin-left: 5px; color: #409EFF; cursor: pointer;" 
                            @click="goToProjectDetail(scope.row.project)" 
                            title="View Project Details">
                        </i>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="" label="Sign Up Date" width="190px">
                <template slot-scope="scope">
                    <p v-html="convertTimeToEng(scope.row.create_time)"></p>
                    <!-- {{ convertTimeToEng(scope.row.create_time) }} -->
                    <!-- {{ $dayjs(scope.row.create_time * 1000).format("MMM DD,&nbsp;YYYY") }} -->
                </template>
            </el-table-column>
            <el-table-column prop="" label="Program Status" width="160px">
                <template slot-scope="scope">
                    <el-tag
                        :type="getStatusType(scope.row)"
                        size="small">
                        {{ getStatusLabel(scope.row) }}
                    </el-tag>
                    
                    <div v-if="scope.row.project?.project_need_teaming == 'YES'" style="margin-top: 5px">
                        <el-tag
                            type="info"
                            size="small"
                            >
                            {{ scope.row.application_team_code && scope.row.application_status != '' ? 'in Team ' + scope.row.application_team_code : 'Not Teamed Yet' }}
                        </el-tag>
                        

                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="" label="Result" width="160px"></el-table-column> -->
            <el-table-column prop="" label="Operation">
                <template slot-scope="scope">
                    <div class="operations-container">
                        <div class="admin-operations">
                            <!-- Primary CTAs -->
                            <el-button 
                                type="primary"
                                size="small" 
                                v-if="scope.row.application_status == '待缴费'"
                                @click="gotoPay(scope.row._id.$id)">
                                Payment Details
                            </el-button>
                            <el-button
                                plain
                                type="danger"
                                size="small"
                                v-if="canCancelApplication(scope.row)"
                                @click="doCancel(scope.row._id.$id)">
                                Cancel Registration
                            </el-button>
                            <el-button
                                plain
                                type="warning"
                                size="small"
                                :loading="qualificationUpdatingId === scope.row._id.$id"
                                v-if="isPendingLearningFirstQualification(scope.row)"
                                @click="updateQualificationStatus(scope.row)">
                                Update Qualification Status
                            </el-button>

                            <!-- Program -->
                            <el-dropdown 
                                v-if="hasProgramActions(scope.row) && !isPendingLearningFirstQualification(scope.row)"
                                trigger="click" 
                                @command="cmd => handleAction(cmd, scope.row)">
                                <el-button plain type="primary" size="small" class="category-button">
                                    Program
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item 
                                        v-if="scope.row.project.exam_time_arr && scope.row.project.exam_time_arr.length > 0" 
                                        command="viewExams">
                                        View Exams
                                    </el-dropdown-item>
                                    <el-dropdown-item 
                                        v-if="scope.row.projectManage" 
                                        command="viewTimeline">
                                        View Timeline
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>

                            <!-- Resources dropdown -->
                            <el-dropdown 
                                v-if="hasResourceActions(scope.row)" 
                                trigger="click" 
                                @command="cmd => handleResourceAction(cmd, scope.row)">
                                <el-button plain type="primary" size="small" class="category-button">
                                    Resources
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item 
                                        v-if="scope.row.project.project_BU == 'WAO' && !isProgramAccessLocked(scope.row) && isTestUser == true"
                                        command="resourceCenter">
                                        ResourceCenter
                                    </el-dropdown-item>
                                    <el-dropdown-item 
                                        v-if="checkShowOfficialCourseButton(scope.row) == true"
                                        command="officialCourse">
                                        Official Course
                                    </el-dropdown-item>
                                    <el-dropdown-item 
                                        v-if="scope.row.project.project_status != 'active' && scope.row.project.project_score_show == 'show' && (scope.row.application_status == '已缴费' || scope.row.application_status == '无需缴费')"
                                        command="certificate">
                                        Certificate
                                    </el-dropdown-item>
                                    <!--
                                    <el-dropdown-item 
                                        v-if="scope.row.application_team_code && scope.row.application_status !== ''"
                                        command="viewTeamMembers">
                                        View Team Members
                                    </el-dropdown-item>
                                    -->
                                    <el-dropdown-item 
                                        v-if="!isProgramAccessLocked(scope.row)"
                                        command="receipt">
                                        Receipt
                                    </el-dropdown-item>
                                    <!-- Case operations -->
                                    <template v-for="(case_item, index) in scope.row.case_array" v-if="scope.row.application_status == '已缴费' || scope.row.application_status == '无需缴费'">
                                        <el-dropdown-item 
                                            v-if="case_item.case_button_status >= 0 && case_item.case_button_status == 1"
                                            :key="'case-' + index"
                                            :command="'case-' + index">
                                            {{ case_item.case_title }}
                                        </el-dropdown-item>
                                        <el-dropdown-item 
                                            v-if="case_item.case_button_status >= 0 && case_item.case_button_status == 0"
                                            :key="'case-disabled-' + index"
                                            disabled>
                                            {{ case_item.case_title }} (Not Released)
                                        </el-dropdown-item>
                                        <el-dropdown-item 
                                            v-if="case_item.submit_button_status >= 0 && case_item.submit_button_status == 1"
                                            :key="'submit-' + index"
                                            :command="'submit-' + index">
                                            Submit
                                        </el-dropdown-item>
                                        <el-dropdown-item 
                                            v-if="case_item.submit_button_status >= 0 && case_item.submit_button_status == 0"
                                            :key="'submit-disabled-' + index"
                                            disabled>
                                            Submit (Closed)
                                        </el-dropdown-item>
                                    </template>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <div class="empty-bottom"></div>


        <el-dialog :visible.sync="showStudentSubmissionDialog" width="35%">
            <div style="margin-top: -30px;width: 100%;padding: 0px 20px;">
                <p style="text-align: center;color: #ff6450;font-size: 28px;font-weight: bold;">Submission</p>
                <el-form :model="studentSubmissionInfo" label-position="top" label-width="140px"
                    style="margin-top: 20px;">
                    <el-form-item label="Paste only the requested URL. Do not add anything else.">
                        <el-input v-model="studentSubmissionInfo.content_url" :disabled="studentSubmissionSubmitting"
                            style="width: 100%;"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="flex items-center justify-center">
                    <el-button size="medium" :disabled="studentSubmissionSubmitting"
                        @click="showStudentSubmissionDialog = false">Cancel</el-button>
                    <el-button type="primary" size="medium" :loading="studentSubmissionSubmitting"
                        @click="saveStudentSubmissionInfo">Submit</el-button>
                </div>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="showViewExamsDialog" width="70%">
            <div style="margin-top: 0px;width: 100%;padding: 0px 20px;" >
                <p style="text-align: center;color: #ff6450;font-size: 28px;font-weight: bold;">View Exams</p>
                <p style="font-size:16px;text-align: center;margin-top: 20px;">You may only enter the exam between Entry Open Time and Entry Close Time. <br>The exam timer starts only when you enter, and you will have the full exam time from then on.
                </p>
            </div>    
            <div style="margin-top: 0px;width: 100%;padding: 0px 20px;" v-if="viewProject.account_application?.custom_exam_time != '是' && viewProject.student_supplementary_exam_time != '是'">
                
                <h2 style="text-align: center;margin-top: 20px;">{{viewProject.project_ename}}</h2>
                <p style="font-size:16px;text-align: center;margin-top: 20px;">
                    The dates and times for Entry Open and Entry Close refer to the local time of each continent where your school is located.<br>
          (Asia &amp; Oceania: GMT+8, Europe &amp; Africa: GMT+1, North &amp; South America: GMT-4).
          <br>If you will be travelling internationally, you need to apply for custom exam time.

                </p>
                
                

                
                    <el-table :data="viewProject.exam_time_arr" style="width: 100%; margin-top: 20px;">
                        <el-table-column prop="name" label="Exam Name" align="center"></el-table-column>
                        <el-table-column prop="template.exam_type" label="Exam Type" align="center"></el-table-column>
                        <el-table-column label="Time to Exam" align="center">
                            <template slot-scope="scope">
                                <span :style="getCountdownStyle(getCountdownForStandard(scope.row))">{{getCountdownForStandard(scope.row)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Entry Open Time" align="center">
                            <template slot-scope="scope">
                                {{scope.row.exam_begin_time_str}} {{studentTimezone}}
                            </template>
                        </el-table-column>
                        <el-table-column label="Entry Close Time" align="center">
                            <template slot-scope="scope">
                                {{scope.row.exam_end_time_str}} {{studentTimezone}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="template.test_duration" label="Exam Duration" align="center">
                            <template slot-scope="scope">
                                {{scope.row.template?.test_duration}} mins
                            </template>
                        </el-table-column>
                    </el-table>
            </div>
            
            <div v-if="viewProject.account_application?.custom_exam_time == '是' && viewProject.student_supplementary_exam_time != '是'">
                
                <h2 style="text-align: center;margin-top: 20px;">Custom Exam Time of Your School</h2>
                <div style="font-size:16px;text-align: center;margin-top: 20px;">
                    <p>If your school has applied for a custom exam time per our policies, <br>please refer to your school's custom schedule.</p>
                </div>
                <div v-if="viewProject && viewProject.account_application.event_meeting_room_array">
                    <el-table 
                        :data="Object.values(viewProject.account_application.event_meeting_room_array)" 
                        style="width: 100%; margin-top: 20px;">
                        <el-table-column prop="event_name" label="Exam Name" align="center">
                          <template slot-scope="scope">
                            {{scope.row[0]?.name}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="template.exam_type" label="Exam Type" align="center">
                          <template slot-scope="scope">
                            {{scope.row[0].template?.exam_type}}
                          </template>
                        </el-table-column>
                        <el-table-column label="Time to Exam" align="center">
                          <template slot-scope="scope">
                            <span :style="getCountdownStyle(getCountdownForCustom(scope.row))">{{getCountdownForCustom(scope.row)}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="Entry Open Time" align="center">
                          <template slot-scope="scope">
                            {{scope.row[0]?.event_start_time ? convertTimeToEng(scope.row[0].event_start_time) : ''}}
                          </template>
                        </el-table-column>
                        <el-table-column label="Entry Close Time" align="center">
                          <template slot-scope="scope">
                            {{scope.row[0]?.event_end_time ? convertTimeToEng(scope.row[0].event_end_time) : ''}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="template.test_duration" label="Exam Duration" align="center">
                          <template slot-scope="scope">
                            {{scope.row[0].template?.test_duration}} mins
                          </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-else style="text-align: center; padding: 20px;">
                    <p>No custom exam schedule available.</p>
                </div>
            </div>
            <div v-if="viewProject.student_supplementary_exam_time == '是'">
                
                <h2 style="text-align: center;margin-top: 20px;">Your Individual Custom Exam Time</h2>
                <div style="font-size:16px;text-align: center;margin-top: 20px;">
                    <p>If you have applied for a custom exam time per our policies, <br>please refer to your custom schedule.</p>
                </div>
                <div v-if="viewProject && viewProject.student_event_meeting_room_array">
                    <el-table 
                        :data="Object.values(viewProject.student_event_meeting_room_array)" 
                        style="width: 100%; margin-top: 20px;">
                        <el-table-column prop="" label="Exam Name" align="center">
                          <template slot-scope="scope">
                            {{scope.row[0].name}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="" label="Exam Type" align="center">
                          <template slot-scope="scope">
                            {{scope.row[0].type}}
                          </template>
                        </el-table-column>
                        <el-table-column label="Time to Exam" align="center">
                          <template slot-scope="scope">
                            <span :style="getCountdownStyle(getCountdownForCustom(scope.row))">{{getCountdownForCustom(scope.row)}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="" label="Entry Open Time" align="center">
                          <template slot-scope="scope">
                            {{scope.row[0].event_start_time ? convertTimeToEngByTimezone(scope.row[0].event_start_time, scope.row[0].timezone) : ''}}
                            <span v-if="scope.row[0].timezone" style="color:#999;font-size:12px;"> ({{scope.row[0].timezone}})</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="" label="Entry Close Time" align="center">
                          <template slot-scope="scope">
                            {{scope.row[0].event_end_time ? convertTimeToEngByTimezone(scope.row[0].event_end_time, scope.row[0].timezone) : ''}}
                            <span v-if="scope.row[0].timezone" style="color:#999;font-size:12px;"> ({{scope.row[0].timezone}})</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="template.test_duration" label="Exam Duration" align="center">
                          <template slot-scope="scope">
                            {{scope.row[0].template ? scope.row[0].template.test_duration : ''}} mins
                          </template>
                        </el-table-column>
                        <el-table-column prop="" label="Status" align="center">
                          <template slot-scope="scope">
                            <el-tag
                              :type="scope.row[0].status === 'approved' ? 'success' : 
                                     scope.row[0].status === 'pending' ? 'warning' : 'info'">
                              {{ scope.row[0].status === 'approved' ? 'Approved' :
                                 scope.row[0].status === 'pending' ? 'Pending Review' : scope.row[0].status === 'standard' ? 'Standard' : 'Not Submitted' }}
                            </el-tag>
                          </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-else style="text-align: center; padding: 20px;">
                    <p>No custom exam schedule available.</p>
                </div>
            </div>
            <div style="margin-top: 20px; text-align: center; ">
                <div style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
                    <el-tooltip
                        :disabled="!isAmCustomTestTimeDisabled"
                        content="Custom test time cannot be requested for Academic Marathon (AM) programs in EAE. Please use the remote exam system schedule."
                        placement="top">
                        <span style="margin-right: 10px; display: inline-block;">
                            <el-button 
                                type="primary" 
                                size="medium" 
                                plain
                                :disabled="isAmCustomTestTimeDisabled"
                                @click="openCustomTestTimeDialog">
                                Apply for Custom Test Time
                            </el-button>
                        </span>
                    </el-tooltip>
                    <el-button 
                        type="primary" 
                        size="medium" 
                        :disabled="isViewProjectPendingQualification"
                        @click="openExamSystem()">
                        Go to the Remote Exam System
                    </el-button>
                </div>
                <p v-if="isAmCustomTestTimeDisabled" style="margin-top: 10px; color: #909399;">
                    Custom test time is not available for Academic Marathon (AM) programs in EAE.
                </p>
                <p v-if="isViewProjectPendingQualification" style="margin-top: 10px; color: #e6a23c;">
                    Your qualification is pending. Please update your qualification status before entering the exam system.
                </p>
                <p style="margin-top: 10px;">The login credentials will be the same as those for this EAE system.</p>
                <p style="margin-top: 10px; color: red;">More details about the exam will be available in the remote exam system (rules, policies, interfaces, exam settings, etc.).</p>
                
            </div>
        </el-dialog>

        <el-dialog :visible.sync="showTimelineDialog" title="Project Timeline" width="70%">
            <div style="margin-top: 0px;width: 100%;padding: 0px 20px;">
                <p style="text-align: center;color: #ff6450;font-size: 28px;font-weight: bold;">
                    {{ timelineProject?.project_ename || 'Project Timeline' }}
                </p>
                
                <el-table :data="timelineData" style="width: 100%; margin-top: 20px;">
                    <el-table-column prop="name" label="Phase" align="center"></el-table-column>
                    
                    <el-table-column prop="ddl_date_str" align="center">
                        <template slot="header">
                            <span>Deadline for<br>Student Exam/Work Entry</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="announce_date_str" label="Results Announcement" align="center"></el-table-column>
                    
                    <el-table-column label="Status" align="center">
                        <template slot-scope="scope">
                            <span :style="{color: getStatusColor(scope.row)}">
                                {{ getCurrentStatus(scope.row) }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div style="font-size: 14px; margin-top: 20px; color: #606266;">
                    <p>* All dates are shown in your local timezone.</p>
                    <p>* Please make sure to complete submissions of exams/works before the deadlines.</p>
                    <p>* For the result announcement, the announcement notification email will be sent at any time of the day depending on the progress and capacity of the results calibration. Please give some patience and do not send any enquires about the results during the day.</p>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="showTeamMembersDialog" title="Team Members" width="70%">
            <div style="margin-top: 0px;width: 100%;padding: 0px 20px;">
                <p style="text-align: center;color: #ff6450;font-size: 24px;font-weight: bold;white-space: nowrap;">
                    {{ currentTeam?.project?.project_ename || 'Team Members' }}
                </p>
                <p style="text-align: center;font-size: 16px;margin-bottom: 20px;">
                    Team Code: <span style="font-weight: bold">{{ currentTeam?.application_team_code || 'N/A' }}</span>
                </p>
                
                <el-table :data="teamMembers" style="width: 100%;" v-loading="loadingTeamMembers">
                    <el-table-column prop="student_givenName_pinyin" label="Name" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.student_givenName_pinyin }} {{ scope.row.student_lastName_pinyin }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="account_nameE" label="Institution" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.account_nameEN }}
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="student_email" label="Email" align="center"></el-table-column>
                </el-table>
                
                <div v-if="teamMembers.length === 0 && !loadingTeamMembers" 
                     style="text-align: center; padding: 20px;">
                    <p>No team members found.</p>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="showCustomTestTimeDialog" title="Request Custom Test Time" width="80%">
            <div style="margin-top: 0px; width: 100%; padding: 0px 20px;">
                <div class="custom-time-policy">
                    <p class="custom-time-policy__title">Custom test time policy</p>
                    <ul class="custom-time-policy__list">
                        <li>A custom test time no more than {{ customExamAutoApproveDays }} days before or after the standard test time is automatically approved.</li>
                        <li>A request more than {{ customExamAutoApproveDays }} days from the standard test time is an exception request and will normally be rejected. Approval is considered only for serious, unavoidable circumstances.</li>
                        <li>Scheduled classes, other projects or competitions, extracurricular activities, personal travel, work, and other obligations do not qualify for an exception.</li>
                    </ul>
                    <p style="margin: 0; line-height: 1.6;">
                        * If you only need to customize some of the sessions, please keep the other sessions with the standard time unchanged.
                    </p>
                    <p v-if="isWECProjectCode(viewProject?.project_code) && viewProject?.application_team_code"
                       style="margin: 10px 0 0; line-height: 1.6; color: #e6a23c; font-weight: 600;">
                        * WEC is a team event. This request applies to every member of Team {{ viewProject.application_team_code }}, and all team members must use the same exam time.
                    </p>
                </div>
                <p style="text-align: center; color: #ff6450; font-size: 24px; font-weight: bold;">
                    {{ viewProject?.project_ename }}
                </p>
                <p style="text-align: center; color: #666; font-size: 14px; margin-bottom: 10px;">
                    Your local timezone: <strong>{{ getLocalTimezone() }}</strong>
                </p>
                
                <el-table :data="viewProject.student_event_meeting_room_array ? Object.values(viewProject.student_event_meeting_room_array) : []" :key="tableKey" style="width: 100%; margin-top: 20px;">
                    <el-table-column prop="" label="Exam Name" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row[0]?.name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="Exam Type" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row[0].type}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="Time Zone" align="center" width="200px">
                        <template slot-scope="scope">
                            <el-select 
                                :value="scope.row[0].timezone"
                                @input="onTimezoneChange($event, scope.row[0])"
                                placeholder="Select timezone">
                                <el-option v-for="(zone,index) in timezones" :key="index" :label="zone" :value="zone"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>

                    <el-table-column prop="" label="Exam Open Time" align="center">
                        <template slot-scope="scope">
                            <el-date-picker
                                :value="getAdjustedTimeByTimezone(scope.row[0].event_start_time, scope.row[0].timezone)"
                                @input="updateEventTime($event, scope.row[0])"
                                type="datetime"
                                placeholder="Please select"
                                format="yyyy-MM-dd HH:mm"
                                value-format="timestamp"
                                :disabled="false"
                                :editable="false">
                            </el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="Exam Close Time" align="center">
                        <template slot-scope="scope">
                            <span>
                                {{ convertTimeToEngByTimezone(scope.row[0].event_start_time + scope.row[0].duration, scope.row[0].timezone) }}
                            </span>
                        </template>
                    </el-table-column>
       
                    <!-- <el-table-column prop="" label="Duration" align="center">
                        <template slot-scope="scope">
                            <span> -->
                                <!-- {{ scope.row[0].duration/60000}} mins -->
                                <!-- {{ scope.row[0].template ? scope.row[0].template.test_duration : '' }} mins -->
                            <!-- </span>
                        </template>
                    </el-table-column> -->
                    
                </el-table>
                
            </div>
            <div class="custom-time-reason">
                <p class="custom-time-reason__title">Exception reason</p>
                <p class="custom-time-reason__help">
                    Leave this section blank if every selected session is within {{ customExamAutoApproveDays }} days of the standard test time. As a rule, requests outside the {{ customExamAutoApproveDays }}-day window are rejected unless they fall under one of the exceptional circumstances listed below. Selecting a reason and providing details does not guarantee approval.
                </p>
                <el-select
                    v-model="customTestTimeForm.reasonCategory"
                    placeholder="Select only if exception review is required"
                    style="width: 100%; margin-bottom: 12px;">
                    <el-option
                        v-for="option in customExamExceptionReasons"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value">
                    </el-option>
                </el-select>
                <el-input
                    type="textarea"
                    v-model="customTestTimeForm.reasonDetails"
                    :rows="4"
                    :placeholder="'Describe what happened, the relevant dates, and why you cannot take the test within the ' + customExamAutoApproveDays + '-day window.'"
                    style="width: 100%">
                </el-input>
            </div>
            
            <span slot="footer" class="dialog-footer">
                <div style="display: flex; justify-content: center; gap: 20px;">
                    <el-button @click="showCustomTestTimeDialog = false">Cancel</el-button>
                    <el-button
                        type="primary"
                        :loading="customTestTimeSubmitting"
                        :disabled="customTestTimeSubmitting"
                        @click="submitCustomTestTime">
                        Submit Request
                    </el-button>
                </div>
            </span>
        </el-dialog>


    </div>
</template>
<script>
import {
    updateStudentSubmission,
    getStudentSubmissionByApplication,
    checkApplication,
    cancelApplication,
    getStudentApplications,
    updateLearningFirstQualificationStatus,
    postRequest,
    generateCrossLoginToken
} from '../../api/eae'

import '../../assets/common/font.css'
import {
    isTestUser,
    getUserId,
    getUserType,
    getAccountContinent
} from '../../utils/store'
import {
    CUSTOM_EXAM_AUTO_APPROVE_DAYS,
    CUSTOM_EXAM_EXCEPTION_REASONS
} from '../../utils/customExamTimePolicy'
import { normalizeCustomExamWindow } from '../../utils/customExamTimeWindow'
export default ({
    name: 'index',
    data() {
        return {
            continent_std_timezones: {
                'Asia': 'GMT+8',
                'Europe': 'GMT+1',
                'Africa': 'GMT+1',
                'North America': 'GMT-4',
                'South America': 'GMT-4',
                'Oceania': 'GMT+8'
            },
            
            timezones: [],
            isTestUser: isTestUser(),
            studentSubmissionInfo: {
                id: '',
                application_id: '',
                content_url: ''
            },
            studentSubmissionSubmitting: false,
            showStudentSubmissionDialog: false,
            dataList: [],
            qualificationUpdatingId: '',
            showViewExamsDialog: false,
            viewProject: {
                student_event_meeting_room_array: null,
                // Other properties with default values
            },
            showTimelineDialog: false,
            timelineProject: null,
            timelineData: [],
            showTeamMembersDialog: false,
            teamMembers: [],
            currentTeam: null,
            loadingTeamMembers: false,
            showCustomTestTimeDialog: false,
            customTestTimeSubmitting: false,
            customTestTimeForm: {
                reasonCategory: '',
                reasonDetails: ''
            },
            customExamAutoApproveDays: CUSTOM_EXAM_AUTO_APPROVE_DAYS,
            customExamExceptionReasons: CUSTOM_EXAM_EXCEPTION_REASONS,
            tableKey: 0,
            account_continent: getAccountContinent(),
            countdownTimer: null,
            nowTimestamp: Date.now(),
            studentTimezone: ''
        }
    },
    computed: {
        isAmCustomTestTimeDisabled() {
            return !!(this.viewProject && this.viewProject.project_BU === 'AM')
        },
        isViewProjectPendingQualification() {
            return !!(this.viewProject && this.viewProject.qualification_status === 'pending_qualification')
        }
    },
    mounted() {
        for(let i=-12;i<=14;i++){
            if(i == 0){
                this.timezones.push('GMT+0')
            }else {
                if(i > 0) {
                    this.timezones.push('GMT+'+(i-0.5))
                    this.timezones.push('GMT+'+i)
                }else {
                    this.timezones.push('GMT'+i)
                    this.timezones.push('GMT'+(i+0.5))
                }
            }
        }
        console.log('timezones :' + JSON.stringify(this.timezones))
        this.fetchData()
        this.countdownTimer = setInterval(() => {
            this.nowTimestamp = Date.now()
        }, 1000)
    },
    beforeDestroy() {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer)
        }
    },
    methods: {

        downloadInvoice(row){
            if (!row || !row._id) {
                this.$message.warning('Receipt not available')
                return
            }
            this.$router.push({
                path: '/home/schoolInvoice',
                query: {
                    id: row._id.$id,
                    document: 'receipt'
                }
            })
        },

        checkShowOfficialCourseButton(row) {
            if (row.project.project_classes && row.project.project_classes.length > 0 && !this.isProgramAccessLocked(row)) {
                if (row.project.project_code == '2025Envirothon_Asia' && row.internationnal_student == false) {
                    return false
                }
                return true
            }
            return false
        },

        gotoResourceCenter(row) {
            this.$router.push({
                path: '/home/resource-center/wao',
                query: {
                    project_code: row.project.project_code,
                    project_name: row.project.project_ename
                }
            })
        },

        gotoClassManageView(row) {
            this.$router.push({
                path: '/home/official_course',
                query: {
                    project_code: row.project.project_code,
                    class_id: row.project.project_classes[0]
                }
            })
        },

        openMaterialLink(link) {
            window.open(link, '_blank')
        },

        gotoAwardView(row) {
            this.$router.push({
                path: '/award',
                query: {
                    id: row._id.$id
                }
            })
        },

        saveStudentSubmissionInfo() {
            const contentUrl = (this.studentSubmissionInfo.content_url || '').trim()
            if (contentUrl == '') {
                this.$message.warning('Please enter the submission URL.')
                return
            }

            let submissionUrl
            try {
                submissionUrl = new URL(contentUrl)
            } catch (error) {
                this.$message.error('Please provide a valid URL.')
                return
            }
            if (submissionUrl.protocol !== 'http:' && submissionUrl.protocol !== 'https:') {
                this.$message.error('Please provide a valid http or https URL.')
                return
            }

            this.studentSubmissionInfo.content_url = contentUrl
            this.studentSubmissionSubmitting = true
            updateStudentSubmission(this.studentSubmissionInfo).then((res) => {
                const result = res && res.data
                if (!result || result.code !== 0) {
                    throw new Error(result && result.msg ? result.msg : 'Submission failed. Please try again.')
                }

                this.showStudentSubmissionDialog = false
                this.$alert('Your submission has been saved successfully.', 'Submission Successful', {
                    confirmButtonText: 'OK',
                    type: 'success'
                }).catch(() => {})
            }).catch((error) => {
                const responseMessage = error && error.response && error.response.data && error.response.data.msg
                this.$message.error(responseMessage || error.message || 'Submission failed. Please try again.')
            }).finally(() => {
                this.studentSubmissionSubmitting = false
            })
        },

        doShowStudentSubmissionDialog(row) {
            getStudentSubmissionByApplication(row._id.$id).then((res) => {
                let result = res.data.data
                if (result) {
                    this.studentSubmissionInfo = {
                        id: result._id.$id,
                        application_id: row._id.$id,
                        content_url: result.content_value
                    }
                } else {
                    this.studentSubmissionInfo = {
                        id: '',
                        application_id: row._id.$id,
                        content_url: ''
                    }
                }
                
                // Check if submission is late (past deadline but within 12 hour extension)
                if (row.project && row.project.case_time_arr && row.project.case_time_arr.length > 0) {
                    let current_time = parseInt(new Date().getTime() / 1000)
                    for (let item of row.project.case_time_arr) {
                        if (item.case_submission_ddl && item.case_submission_ddl != false) {
                            if (current_time > item.case_submission_ddl && current_time <= item.case_submission_ddl + 43200) {
                                // Show late submission warning
                                this.$alert('Your submission is past the deadline. A penalty of 10 points will be imposed for late submission.', 'Late Submission Warning', {
                                    confirmButtonText: 'I Understand',
                                    type: 'warning'
                                }).then(() => {
                                    this.showStudentSubmissionDialog = true
                                })
                                return
                            }
                        }
                    }
                }
                
                this.showStudentSubmissionDialog = true
            })
        },

        fetchData() {

            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading", 
                background: "rgba(0, 0, 0, 0.7)",
            });
            getStudentApplications(getUserId()).then((res) => {
                let result = res.data.data
                result = (result || []).filter((application) => {
                    const bu = application.project && application.project.project_BU
                        ? String(application.project.project_BU).toUpperCase()
                        : ''
                    return bu !== 'DSA'
                })
                result.map((application) => {
                    let case_array = [];
                    if (!this.isProgramAccessLocked(application)) {
                        let project = application.project
                        let eae_submission_show = ''
                        if(project && project.eae_submission_show){
                            eae_submission_show = project.eae_submission_show
                        }
                        
                        if (project && project.case_time_arr) {


                            for (let i = 0; i < project.case_time_arr.length; i++) {

                                let case_button_status = -1
                                let submit_button_status = -1
                                let case_title = ''
                                let case_material_url = ''

                                let item = project.case_time_arr[i]
                                let case_release_time = item.case_release_time
                                let case_submission_ddl = item.case_submission_ddl
                                case_material_url = item.case_material_url
                                let current_time = parseInt(new Date().getTime() / 1000)
                                case_title = item.case_title
                                if (current_time > case_release_time) {
                                    case_button_status = 1
                                } else {
                                    case_title = item.case_title
                                    case_button_status = 0
                                }
                                if (case_submission_ddl && case_submission_ddl != false) {
                                    // Add 12 hour extension (12 * 60 * 60 = 43200 seconds)
                                    let deadline_with_extension = case_submission_ddl + 43200
                                    if (current_time > deadline_with_extension) {
                                        submit_button_status = 0
                                    } else {
                                        submit_button_status = 1
                                    }
                                }
                                if(eae_submission_show && eae_submission_show == 'hide'){
                                    submit_button_status = -1
                                }
                                let case_item = []
                                case_item['case_button_status'] = case_button_status
                                case_item['submit_button_status'] = submit_button_status
                                case_item['case_title'] = case_title
                                case_item['case_material_url'] = case_material_url
                                case_item['case_release_time'] = case_release_time
                                case_array.push(case_item)
                            }
                        }
                    }
                    if (application.application_project == '2025Envirothon_Asia' && application.internationnal_student == true) {
                        case_array = []
                        // if(case_array.length >0){
                        //     case_array[0].case_title = 'Official Course'
                        // }
                        // case_button_status = -1
                        // submit_button_status = -1
                    }
                    // case_button_status = 1
                    // submit_button_status = 1
                    // if (application.application_project.project_ename == '2025 World Economics Cup') {
                    //     console.log('case_button_status :' + case_button_status + ', submit_button_status :' + submit_button_status + ', case_title :' + case_title + ',case_material_url : ' + case_material_url)
                    // }
                    application['case_array'] = case_array
                    // application['case_button_status'] = case_button_status
                    // application['submit_button_status'] = submit_button_status
                    // application['case_title'] = case_title
                    // application['case_material_urls'] = case_material_urls
                    return application
                })
                this.dataList = result
                loading.close()
            })
            
        },
        gotoSelectPassView(application_id, project_name) {
            this.$router.push({
                path: '/home/verify-pass',
                query: {
                    application_id: application_id,
                    project_name: project_name
                }
            })
        },

        convertTimeToEngByTimezone(time, timezone) {
            if(time.toString().length == 10){   
                time = time * 1000
            }

            // Apply timezone offset to convert to the target timezone
            //How to ge the current time zone of local machine/local time?

            const local_timezone = parseFloat(this.getLocalTimezone().replace('GMT', ''))

            if (timezone) {
                const offset = parseFloat(timezone.replace('GMT', ''));
                time = time + ((offset-local_timezone) * 60 * 60 * 1000);
            }
            
            let date = new Date(time);
            let year = date.getFullYear();
            let month = (date.getMonth() + 1).toString().padStart(2, '0');
            let day = date.getDate().toString().padStart(2, '0');
            let hours = date.getHours().toString().padStart(2, '0');
            let minutes = date.getMinutes().toString().padStart(2, '0');
            
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        getTimezoneOffsetMs(timezone) {
            if (!timezone || timezone === 'GMT+8') return 0
            if (timezone === 'GMT+1') return 7 * 60 * 60 * 1000
            if (timezone === 'GMT-4') return 12 * 60 * 60 * 1000
            return 0
        },
        getCountdownForStandard(row) {
            if (!row.exam_begin_time) return '-'
            let openTime = row.exam_begin_time
            if (openTime.toString().length === 10) openTime = openTime * 1000
            let endTime = row.exam_end_time
            if (endTime && endTime.toString().length === 10) endTime = endTime * 1000
            let offset = this.getTimezoneOffsetMs(this.studentTimezone)
            openTime += offset
            if (endTime) endTime += offset
            return this.formatCountdown(openTime, endTime)
        },
        getCountdownForCustom(row) {
            if (!row[0]?.event_start_time) return '-'
            let openTime = row[0].event_start_time
            if (openTime.toString().length === 10) openTime = openTime * 1000
            let endTime = row[0]?.event_end_time
            if (endTime && endTime.toString().length === 10) endTime = endTime * 1000
            return this.formatCountdown(openTime, endTime)
        },
        formatCountdown(openTime, endTime) {
            const now = this.nowTimestamp
            if (endTime && now >= endTime) return 'Ended'
            if (now >= openTime) return 'Open Now'
            const diff = openTime - now
            const days = Math.floor(diff / (1000 * 60 * 60 * 24))
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
            const seconds = Math.floor((diff % (1000 * 60)) / 1000)
            if (days > 0) return `${days}d ${hours}h ${minutes}m`
            if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`
            return `${minutes}m ${seconds}s`
        },
        getCountdownStyle(text) {
            if (text === 'Open Now') return 'color: #67C23A; font-weight: bold;'
            if (text === 'Ended') return 'color: #909399;'
            return 'color: #E6A23C; font-weight: bold;'
        },
        convertTimeToEng(time) {
            // Convert to milliseconds if it's in seconds
            if(time.toString().length == 10){   
                time = time * 1000
            }
            // Create date from timestamp (Unix timestamps are always UTC)
            var date = new Date(time);
            let year = date.getUTCFullYear();
            let month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
            let day = date.getUTCDate().toString().padStart(2, '0');
            let hours = date.getUTCHours().toString().padStart(2, '0');
            let minutes = date.getUTCMinutes().toString().padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes} UTC`;
        },
        convertTimeToEngV1(time) {
            var date = new Date(time);
            date = new Date(date.getTime()); // Convert to UTC
            let year = date.getUTCFullYear();
            let month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
            let day = date.getUTCDate().toString().padStart(2, '0');
            let hours = date.getUTCHours().toString().padStart(2, '0');
            let minutes = date.getUTCMinutes().toString().padStart(2, '0');
            let seconds = date.getUTCSeconds().toString().padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes} UTC`;
        },

        formatMonthToEng(month) {
            switch (month) {
                case 1:
                    return "January";
                case 2:
                    return "February";
                case 3:
                    return "March";
                case 4:
                    return "April";
                case 5:
                    return "May";
                case 6:
                    return "June";
                case 7:
                    return "July";
                case 8:
                    return "August";
                case 9:
                    return "September";
                case 10:
                    return "October";
                case 11:
                    return "November";
                case 12:
                    return "December";
            }
        },

        doCancel(application_id) {
            this.$confirm("Are you sure you want to cancel this registration?", "Cancel Registration", { type: "warning", confirmButtonText: "Confirm", })
                .then(() => {
                    cancelApplication(application_id).then((res) => {
                        if (res.data && res.data.code < 0) {
                            this.$message.warning(res.data.msg || 'This registration cannot be canceled.')
                            return
                        }
                        this.$message.success('Registration Canceled Successfully')
                        this.fetchData()
                    })
                    // this.$emit("remove");
                })
        },
        gotoPay(application_id) {
            if (true) {
                checkApplication(application_id).then((res) => {
                    // let application = res.data.data
                    this.toPayView(application_id)
                    // if (application.application_status == '待缴费') {
                    //     this.toPayView(application_id)
                    // } else {
                    // }
                })
                return
            }
        },
        toPayView(application_id) {
            this.$router.push({
                path: '/home/program-order',
                query: {
                    application_id: application_id
                }
            })
        },
        tableCellstyle() {
            return 'background:  #FAE3E4;border:1px solid white;text-align:center; font-family: Ubuntu-Bold;'
        },
        getStatusType(row) {
            if (row && row.qualification_status === 'pending_qualification') {
                return 'warning'
            }
            switch (row && row.application_status) {
                case '待缴费':
                    return 'warning'
                case '已取消':
                    return 'danger'
                case '无需缴费':
                    return 'info'
                case '已缴费':
                    return 'success'
                case 'pending activation':
                    return 'warning'
                default:
                    return 'success'
            }
        },
        isProgramAccessLocked(row) {
            if (!row) return false
            return row.application_status === '待缴费'
                || row.application_status === 'pending activation'
        },
        isComboAwaitingPeerPay(row) {
            if (!row) return false
            return row.application_status === 'pending activation'
        },
        getStatusLabel(row) {
            if(row.application_status =='已取消'){
                return 'Canceled'
            }
            if(row.qualification_status === 'pending_qualification'){
                return 'Pending Qualification'
            }
            // D-3 / D-7: distinguish Paid vs No Payment Required vs Pending Payment
            if(row.application_status === '待缴费'){
                return 'Pending Payment'
            }
            if(this.isComboAwaitingPeerPay(row)){
                return 'Awaiting combo payment'
            }
            if(row.application_status === '已缴费'){
                return 'Paid'
            }
            if(row.application_status === '无需缴费'){
                return 'No Payment Required'
            }
            if(row.project && row.project.project_status === 'inactive'){
                return 'Completed'
            }
            return 'Ongoing'
        },
        getDefaultTimezone(account_continent){
            if(account_continent == 'Asia' || account_continent == 'Oceania'){
                return 'GMT+8'
            }
            if(account_continent == 'Europe' || account_continent == 'Africa') {
                return 'GMT+1'
            }
            if(account_continent == 'North America' || account_continent == 'South America') {
                return 'GMT-4'
            }
            return ''
        },
        formatExamTimeByTimezone(timezone,exam_time){
            if(!timezone){
                return exam_time
            }
            const offset = parseFloat(timezone.replace('GMT', ''))
            if(isNaN(offset)){
                return exam_time
            }
            return exam_time + Math.round((8 - offset) * 3600)
        },
        viewExams(row) {

            this.showViewExamsDialog = true

            this.viewProject = row.project
            this.studentTimezone = this.getDefaultTimezone(row.account_continent)
            this.viewProject.application_id = row._id.$id
            this.$set(this.viewProject, 'qualification_status', row.qualification_status || 'none')
            this.$set(this.viewProject, 'application_team_code', row.application_team_code || '')
            this.$set(this.viewProject, 'custom_exam_time_version', row.custom_exam_time_version || '')
            this.$set(this.viewProject, 'student_event_meeting_room_array', row.event_meeting_room_array)
            this.viewProject.student_supplementary_exam_time = row.supplementary_exam_time

            if(row.supplementary_exam_time == '是'){
                let obj = {};
                let timezone = this.getDefaultTimezone(row.account_continent)
                let keys = Object.keys(this.viewProject.student_event_meeting_room_array)
                for(let i=0; i<keys.length;i++ ){
                    let key = keys[i]
                    let item = JSON.parse(JSON.stringify(this.viewProject.student_event_meeting_room_array[key]))
                    const standardExam = (row.project.exam_time_arr || []).find(exam => exam.name === key)
                    item[0] = normalizeCustomExamWindow(item[0], standardExam)
                    obj[key]= item
                }
                // 对于没有自定义时间的考试，用标准时间填充
                if(row.project.exam_time_arr){
                    for(let i=0; i<row.project.exam_time_arr.length; i++){
                        let exam = row.project.exam_time_arr[i]
                        if(!obj[exam.name]){
                            let new_item = {}
                            new_item['event_start_time'] = this.formatExamTimeByTimezone(timezone, exam.exam_begin_time) * 1000
                            new_item['event_end_time'] = this.formatExamTimeByTimezone(timezone, exam.exam_end_time) * 1000
                            new_item['name'] = exam.name
                            new_item['type'] = exam.exam_type
                            new_item['duration'] = new_item['event_end_time'] - new_item['event_start_time']
                            new_item['timezone'] = timezone
                            new_item['status'] = 'standard'
                            obj[exam.name] = [new_item]
                        }
                    }
                }
                this.$set(this.viewProject, 'student_event_meeting_room_array', obj)
            }else {
                let obj = [];
                let timezone = this.getDefaultTimezone(row.account_continent)
                for(let i=0; i<row.project.exam_time_arr.length;i++){
                    let item = row.project.exam_time_arr[i]
                    let array = [];
                    let new_item = {}
                    new_item['event_start_time'] = this.formatExamTimeByTimezone(timezone,item.exam_begin_time) * 1000
                    new_item['event_end_time'] = this.formatExamTimeByTimezone(timezone,item.exam_end_time) * 1000
                    new_item['name'] = item.name
                    new_item['type'] = item.exam_type
                    new_item['duration'] = new_item['event_end_time'] - new_item['event_start_time']
                    new_item['timezone'] = timezone
                    array.push(new_item)
                    obj[item.name] = array
                }
                this.$set(this.viewProject, 'student_event_meeting_room_array', obj)
            }
            // console.log('student_event_meeting_room_arrasy :' + JSON.stringify(this.viewProject.student_event_meeting_room_array))
            // Check if exam times need to be adjusted based on account application
            postRequest({
                function: 'getAccountApplicationByStudent',
                application_id: row._id.$id
            }).then(res => {
                // if (res.data.data) {
                    // Update exam times with custom schedule if it exists
                    if(res.data.data){
                        this.$set(this.viewProject, 'account_application', res.data.data)
                        this.$set(
                            this.viewProject,
                            'custom_exam_time_version',
                            res.data.data.student_custom_exam_time_version || row.custom_exam_time_version || ''
                        )
                        console.log('viewProject :' + this.viewProject.account_application.event_meeting_room_array)
                    }
                    // 合并学生级pending申请：在Pending状态下显示"申请时间"而不是上一条生效时间
                    const studentPendings = (res.data.data && res.data.data.student_pending_applies) || []
                    if (studentPendings.length > 0) {
                        if (this.viewProject.student_supplementary_exam_time != '是') {
                            this.$set(this.viewProject, 'student_supplementary_exam_time', '是')
                            // 当前 student_event_meeting_room_array 可能是 array 结构（else 分支），
                            // 需要按 '是' 分支的逻辑重建为 {examName: [item]} 的对象结构
                            const obj = {}
                            const timezone = this.getDefaultTimezone(row.account_continent)
                            if (row.project.exam_time_arr) {
                                for (let i = 0; i < row.project.exam_time_arr.length; i++) {
                                    const exam = row.project.exam_time_arr[i]
                                    const new_item = {}
                                    new_item['event_start_time'] = this.formatExamTimeByTimezone(timezone, exam.exam_begin_time) * 1000
                                    new_item['event_end_time'] = this.formatExamTimeByTimezone(timezone, exam.exam_end_time) * 1000
                                    new_item['name'] = exam.name
                                    new_item['type'] = exam.exam_type
                                    new_item['duration'] = new_item['event_end_time'] - new_item['event_start_time']
                                    new_item['timezone'] = timezone
                                    new_item['status'] = 'standard'
                                    obj[exam.name] = [new_item]
                                }
                            }
                            this.$set(this.viewProject, 'student_event_meeting_room_array', obj)
                        }
                        this.overlayPendingApplies(studentPendings, this.viewProject.student_event_meeting_room_array)
                    }
                    this.getExamInfos()
                // }
            }).catch(err => {
                console.error('Error getting account application:', err);
            });

            



            
        },
        openExamSystem() {
            if(this.viewProject.project_BU == 'WAO'){
                window.open('https://my.academic-olympics.world', '_blank');
            }else if(this.viewProject.project_BU == 'AM'){
                let user_id = getUserId()
                let user_type = getUserType()
                const projectCode = this.viewProject.project_code || ''
                generateCrossLoginToken(user_id, user_type, 'AM', projectCode).then(res => {
                    if (res.data.code === 0) {
                        let token = res.data.data.token
                        let examUrl = 'https://arena.academic-marathon.org/#/login?cross_token=' + encodeURIComponent(token)
                            + '&user_id=' + encodeURIComponent(user_id)
                            + '&user_type=' + encodeURIComponent(user_type)
                        if (projectCode) {
                            examUrl += '&project_code=' + encodeURIComponent(projectCode)
                        }
                        window.open(examUrl, '_blank');
                    } else {
                        window.open('https://arena.academic-marathon.org', '_blank');
                    }
                }).catch(() => {
                    window.open('https://arena.academic-marathon.org', '_blank');
                })
            }else{
                window.open('https://exam.learningfirst.io', '_blank');
            }
        },
        getExamInfos(){
            //Get exam infos
            console.log('getExamInfos called')
            if(this.viewProject.student_supplementary_exam_time == '是'){
                //Get supplementary exam infos

                for (let exam_name in this.viewProject.student_event_meeting_room_array) {
                    let exam_info = this.viewProject.student_event_meeting_room_array[exam_name][0]
                    // Get template info for each exam
                    postRequest({
                        function: 'getExerciseTestTemplateInfo',
                        event: exam_info.name,
                        project_code: this.viewProject.project_code,
                        type: exam_info.type
                    }).then(res => {
                        if (res.data.code === 0) {
                            // Add template info to exam info
                            this.$set(this.viewProject.student_event_meeting_room_array[exam_name][0], 'template', res.data.data)
                        } else {
                            console.error('Error getting template:', res.data.msg)
                        }
                    }).catch(err => {
                        console.error('Error getting template:', err)
                    })
                    
                }

                console.log('fdsfdsdsfdfdsfdsfsfd222')
                
            }else if(this.viewProject.account_application && this.viewProject.account_application.custom_exam_time == '是'){
                //Get custom exam infos
                for (let exam_name in this.viewProject.account_application.event_meeting_room_array) {
                    let exam_info = this.viewProject.account_application.event_meeting_room_array[exam_name][0]
                    // Get template info for each exam
                    postRequest({
                        function: 'getExerciseTestTemplateInfo',
                        event: exam_info.name,  
                        project_code: this.viewProject.project_code,
                        type: exam_info.type
                    }).then(res => {
                        if (res.data.code === 0) {
                            // Add template info to exam info
                            this.$set(this.viewProject.account_application.event_meeting_room_array[exam_name][0], 'template', res.data.data)
                        } else {
                            console.error('Error getting template:', res.data.msg)
                        }
                    }).catch(err => {
                        console.error('Error getting template:', err)
                    })
                }

                console.log('fdsfsfsd')
            }else{
                //Get exam infos
                for (let i = 0; i < this.viewProject.exam_time_arr.length; i++) {
                    let exam_info = this.viewProject.exam_time_arr[i]
                    // Get template info for each exam
                    postRequest({
                        function: 'getExerciseTestTemplateInfo',
                        event: exam_info.name,
                        project_code: this.viewProject.project_code,
                        type: exam_info.exam_type
                    }).then(res => {
                        if (res.data.code === 0) {
                            // Add template info to exam info
                            this.$set(this.viewProject.exam_time_arr[i], 'template', res.data.data)
                        } else {
                            console.error('Error getting template:', res.data.msg)
                        }
                    }).catch(err => {
                        console.error('Error getting template:', err)
                    })
                }
            }
        },
        viewTimeline(row) {
            this.timelineProject = row.project;
            this.timelineData = [];
            
            // Process timeline data from projectManage
            if (row.projectManage && row.projectManage.entry_date && row.projectManage.entry_date.length > 0) {
                // Format the dates for each entry
                this.timelineData = row.projectManage.entry_date.map(item => {
                    return {
                        ...item,
                        // Format all date properties
                        start_date_str: this.formatTimestamp(item.start_date),
                        ddl_date_str: this.formatTimestamp(item.ddl_date),
                        announce_date_str: this.formatTimestamp(item.announce_date),
                        cert_date_str: this.formatTimestamp(item.cert_date)
                    };
                });
            }
            
            this.showTimelineDialog = true;
        },
        
        // Helper method to format timestamps
        formatTimestamp(timestamp) {
            if (!timestamp) return 'N/A';

            const date = new Date(timestamp);
            const gmt8Date = new Date(date.getTime() + (8 * 60 * 60 * 1000));
            const utcString = gmt8Date.toUTCString();
            // Extract just the date part: "Sat, 19 Jul 2025" from "Sat, 19 Jul 2025 20:00:00 GMT"
            return utcString.split(' ').slice(1, 4).join(' ');
        },
        // Updated status method considering the phases
        getCurrentStatus(item) {
            const currentTime = Date.now();
            
            if (currentTime < item.start_date) {
                return 'Not Started';
            } else if (currentTime < item.ddl_date) {
                return 'In Progress';
            } else if (currentTime < item.announce_date) {
                return 'Under Review';
            } else if (currentTime < item.cert_date) {
                return 'Results Published';
            } else {
                return 'Completed';
            }
        },
        
        // Updated color method
        getStatusColor(item) {
            const status = this.getCurrentStatus(item);
            
            switch (status) {
                case 'Not Started':
                    return '#909399'; // Gray
                case 'In Progress':
                    return '#409eff'; // Blue
                case 'Under Review':
                    return '#e6a23c'; // Orange
                case 'Results Published':
                    return '#67c23a'; // Green
                case 'Completed':
                    return '#67c23a'; // Green
                default:
                    return '#303133'; // Default
            }
        },
        showTeamMembers(row) {
            console.log('showTeamMembers called with:', row);
            this.currentTeam = row;
            this.teamMembers = [];
            this.showTeamMembersDialog = true;
            this.loadingTeamMembers = true;
            
            // Make API request to get team members
            postRequest({
                function: 'getTeamMembersByApplication',
                application_id: row._id.$id
            }).then(res => {
                if (res.data && res.data.code === 0) {
                    this.teamMembers = res.data.data || [];
                } else {
                    this.$message.error('Failed to load team members: ' + (res.data?.msg || 'Unknown error'));
                    this.teamMembers = [];
                }
                this.loadingTeamMembers = false;
            }).catch(err => {
                console.error('Error fetching team members:', err);
                this.$message.error('Failed to load team members. Please try again later.');
                this.loadingTeamMembers = false;
            });
        },
        overlayPendingApplies(pendingApplies, targetMap) {
            if (!pendingApplies || !targetMap) return
            for (const apply of pendingApplies) {
                const examTime = apply.exam_time || {}
                for (const key in examTime) {
                    const items = examTime[key]
                    if (!items || !items[0]) continue
                    const raw = items[0]
                    let start_time = raw.event_start_time
                    let end_time = raw.event_end_time
                    if (start_time && start_time.toString().length === 10) {
                        start_time = parseInt(start_time) * 1000
                    }
                    if (end_time && end_time.toString().length === 10) {
                        end_time = parseInt(end_time) * 1000
                    }
                    const existing = (targetMap[key] && targetMap[key][0]) ? targetMap[key][0] : {}
                    const standardExam = (this.viewProject.exam_time_arr || []).find(exam => exam.name === key)
                    const merged = normalizeCustomExamWindow(Object.assign({}, existing, {
                        event_start_time: start_time,
                        event_end_time: end_time,
                        timezone: raw.timezone || existing.timezone,
                        name: raw.name || existing.name || key,
                        type: raw.type || existing.type,
                        status: 'pending'
                    }), standardExam)
                    this.$set(targetMap, key, [merged])
                }
            }
        },
        submitCustomTestTime() {
            if (this.customTestTimeSubmitting) return
            let application_id = this.viewProject.application_id
            let obj = {};
            let keys = Object.keys(this.viewProject.student_event_meeting_room_array)
            for(let i=0; i<keys.length;i++ ){
                let key = keys[i]
                let item = this.viewProject.student_event_meeting_room_array[key]
                let array = [];
                let new_item = {}
                const standardExam = (this.viewProject.exam_time_arr || []).find(exam => exam.name === key)
                const normalizedItem = normalizeCustomExamWindow(item[0], standardExam)
                let start_time = normalizedItem.event_start_time
                let end_time = normalizedItem.event_end_time
                let name = normalizedItem.name
                let type = normalizedItem.type
                let timezone = normalizedItem.timezone
                if(!start_time || start_time == '' ){
                    this.$message.warning('Please select exam open time .')
                    return
                }
                if(!normalizedItem.duration || end_time <= start_time){
                    this.$message.error('The exam close time for ' + (name || key) + ' must be later than its open time.')
                    return
                }
                if(!timezone || timezone == '' ){
                    this.$message.warning('Please select timezone.')
                    return
                }

                new_item['event_start_time'] =  parseInt(start_time)
                new_item['event_end_time'] = parseInt(end_time)
                new_item['name'] = name
                new_item['type'] = type
                new_item['timezone'] = timezone
                array.push(new_item)
                obj[key] = array                 
                this.$set(item, 0, normalizedItem)
            }
            let params = {
                application_id: application_id,
                supplementary_exam_time:"是",
                event_meeting_room_array: obj,
                reason: this.customTestTimeForm.reasonDetails.trim(),
                reason_category: this.customTestTimeForm.reasonCategory,
                reason_details: this.customTestTimeForm.reasonDetails.trim(),
                apply_type: 'student',
                expected_custom_exam_time_version: this.viewProject.custom_exam_time_version || '',
            }
            if(false){
                console.log('params :' + JSON.stringify(params))
                return
            }
                    this.customTestTimeSubmitting = true
                    postRequest({
                      function: 'requestStudentCustomTestTime',
                      ...params
                    }).then(res => {
                      this.customTestTimeSubmitting = false
                      if (res.data && res.data.code === 0) {
                        let resultData = res.data.data;
                        let autoApproved = resultData.auto_approved || [];
                        let pending = resultData.pending || [];
                        const autoApproveDays = resultData.auto_approve_days || this.customExamAutoApproveDays;
                        let msgParts = [];
                        if (resultData.team_applied) {
                          msgParts.push('<b>WEC team schedule:</b><br>This request applies to all ' + resultData.team_member_count + ' members of Team ' + this.viewProject.application_team_code + '.');
                        }
                        if (autoApproved.length > 0) {
                          msgParts.push('<b>Auto-approved (within ' + autoApproveDays + ' days of standard time):</b><br>' + autoApproved.join(', '));
                        }
                        if (pending.length > 0) {
                          msgParts.push('<b>Submitted for review:</b><br>' + pending.join(', '));
                        }
                        let msg = msgParts.join('<br><br>');
                        this.$alert(msg, 'Custom Test Time Request Result', {
                          dangerouslyUseHTMLString: true,
                          confirmButtonText: 'I understand',
                          callback: () => {
                            this.showCustomTestTimeDialog = false;
                            this.showViewExamsDialog = false;
                            this.fetchData();
                          }
                        });
                      } else if (res.data && res.data.code === -4) {
                        this.$alert(
                          res.data.msg || 'This team schedule was updated by another member. Please review the latest time before submitting again.',
                          'Team Schedule Updated',
                          {
                            type: 'warning',
                            confirmButtonText: 'Refresh schedule',
                            callback: () => {
                              this.showCustomTestTimeDialog = false;
                              this.showViewExamsDialog = false;
                              this.fetchData();
                            }
                          }
                        );
                      } else if (res.data && res.data.code === -3) {
                        this.$message.warning(res.data.msg || 'Please provide an exception reason for test times outside the 5-day window');
                      } else {
                        this.$message.error('Failed to submit request: ' + (res.data?.msg || 'Unknown error'));
                        this.showCustomTestTimeDialog = false;
                        this.showViewExamsDialog = false;
                        this.fetchData();
                      }
                    }).catch(()=>{
                        this.customTestTimeSubmitting = false
                        this.showCustomTestTimeDialog = false;
                        this.showViewExamsDialog = false;
                        this.fetchData();
                    });
        },
        
        // Helper method to combine date and time
        combineDateTime(date, time) {
            if (!date || !time) return null;
            
            // Create a new date object from the timestamp
            const dateObj = new Date(date);
            // Extract hours and minutes from the time picker value
            const timeObj = new Date(time);
            const hours = timeObj.getHours();
            const minutes = timeObj.getMinutes();
            
            // Set the hours and minutes to the date
            dateObj.setHours(hours, minutes, 0, 0);
            
            // Return the combined timestamp
            return dateObj.getTime();
        },
        goToProjectDetail(project) {
            // Implement the logic to navigate to the project detail page
            console.log('Going to project detail:', project);
            this.$router.push({
                path: '/home/store/project',
                query: {
                    project_id: project._id.$id,
                    from: 'student'
                }
            })
        },
        openCustomTestTimeDialog() {
            if (this.isAmCustomTestTimeDisabled) {
                this.$message.warning('Custom test time cannot be requested for Academic Marathon (AM) programs in EAE.')
                return
            }

            // if(isTestUser() == true){
                this.customTestTimeForm.reasonCategory = '';
                this.customTestTimeForm.reasonDetails = '';
                this.showCustomTestTimeDialog = true;
            //     return 
            // }
            // if(getUserId() == '61cd6856a4640b946f8b456f'){
            //     this.showCustomTestTimeDialog = true;
            //     return 
            // }
            // this.$message({
            //     message: "The Custom Test Time Application will open soon. Please come back in days",
            //     type: "warning"
            // });
            // console.log('Opening custom test time dialog');
            // this.showCustomTestTimeDialog = true;
        },
        isWECProjectCode(projectCode) {
            return (projectCode || '').includes('WEC')
        },
        getAdjustedTime(row) {
            if (!row.timezone) return row.event_start_time;
            const offset = parseFloat(row.timezone.replace('GMT', ''));
            return row.event_start_time + ((offset - 8) * 60 * 60 * 1000);
        },
        
        getAdjustedTimeByTimezone(time, timezone) {
            if (!timezone) return time;
            const offset = parseFloat(timezone.replace('GMT', ''));
            const local_timezone = parseFloat(this.getLocalTimezone().replace('GMT', ''))
            return time + ((offset - local_timezone) * 60 * 60 * 1000);
        },

        updateEventTime(newTime, row) {
            if (!row.timezone) {
                row.event_start_time = newTime;
                if (Number(row.duration) > 0) {
                    row.event_end_time = newTime + Number(row.duration);
                }
                return;
            }

            // Get timezone offset in hours FIRST
            const tzOffset = parseFloat(row.timezone.replace('GMT', ''));
            
            // Get the user's selected date/time in their timezone
            const userSelectedDate = new Date(newTime);
            console.log('User selected date/time:', userSelectedDate);

            // Get the date components
            const year = userSelectedDate.getFullYear();
            const month = userSelectedDate.getMonth();
            const date = userSelectedDate.getDate();
            
            // Get the time components
            const hours = userSelectedDate.getHours();
            const minutes = userSelectedDate.getMinutes();

            // Create date in UTC then adjust for timezone
            const tzDate = new Date(Date.UTC(year, month, date, hours, minutes));
            
            // Apply timezone offset ONCE
            const timestamp = tzDate.getTime() - tzOffset * 60 * 60 * 1000;
            
            console.log('Timezone adjusted timestamp:', timestamp);
            console.log('For timezone:', row.timezone);
            
            row.event_start_time = timestamp;
            if (Number(row.duration) > 0) {
                row.event_end_time = timestamp + Number(row.duration);
            }
        },

        onTimezoneChange(newTimezone, row) {
            // Force Vue reactivity by using $set
            this.$set(row, 'timezone', newTimezone);
            console.log('Timezone changed to:', newTimezone, 'for row:', row);
            
            // Force table re-render by updating the key
            this.tableKey++;
        },

        getLocalTimezone() {
            // Get the timezone offset in minutes
            const offsetMinutes = new Date().getTimezoneOffset();
            
            // Convert to hours (negative because getTimezoneOffset() returns opposite of what we want)
            const offsetHours = -offsetMinutes / 60;
            
            // Format as GMT string
            if (offsetHours === 0) {
                return 'GMT+0';
            } else if (offsetHours > 0) {
                return `GMT+${offsetHours}`;
            } else {
                return `GMT${offsetHours}`;
            }
        },



        formatCaseReleaseTime(timestamp) {
            if (!timestamp) return 'TBD';
            
            // Convert to milliseconds if it's in seconds
            if (timestamp.toString().length === 10) {
                timestamp = timestamp * 1000;
            }
            
            const date = new Date(timestamp);
            const year = date.getUTCFullYear();
            const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
            const day = date.getUTCDate().toString().padStart(2, '0');
            const hours = date.getUTCHours().toString().padStart(2, '0');
            const minutes = date.getUTCMinutes().toString().padStart(2, '0');
            
            return `${month}/${day}/${year}, ${hours}:${minutes} UTC`;
        },
        hasProgramActions(row) {
            if (row && row.application_status === 'pending activation') {
                return false
            }
            return (row.project.exam_time_arr && row.project.exam_time_arr.length > 0) || !!row.projectManage
        },
        isPendingLearningFirstQualification(row) {
            return row
                && row.qualification_status === 'pending_qualification'
                && row.project
                && row.project.project_need_qualification === 'YES'
                && (row.project.qualification_source === 'lf_bundle' || row.project.qualification_type === 'lf_bundle')
        },
        updateQualificationStatus(row) {
            const applicationId = row && row._id && row._id.$id ? row._id.$id : ''
            if (!applicationId) return
            this.qualificationUpdatingId = applicationId
            updateLearningFirstQualificationStatus(applicationId).then((res) => {
                const result = res && res.data ? res.data : {}
                if (result.code === 0) {
                    if (result.data && result.data.qualified) {
                        this.$message.success('Qualification confirmed.')
                    } else if (result.data && result.data.notice) {
                        this.$message.warning(result.data.notice)
                    } else {
                        this.$message.warning('Your qualification is still pending.')
                    }
                    this.fetchData()
                } else {
                    this.$message.error(result.msg || 'Qualification update failed.')
                }
            }).finally(() => {
                this.qualificationUpdatingId = ''
            })
        },
        hasResourceActions(row) {
            const hasResourceCenter = row.project.project_BU == 'WAO' && !this.isProgramAccessLocked(row) && this.isTestUser == true
            const hasOfficialCourse = this.checkShowOfficialCourseButton(row) == true
            const hasCertificate = row.project.project_status != 'active' && row.project.project_score_show == 'show' && (row.application_status == '已缴费' || row.application_status == '无需缴费')
            const hasTeamMembers = row.application_team_code && row.application_status !== ''
            const hasReceipt = !this.isProgramAccessLocked(row)
            const hasCaseOperations = (row.application_status == '已缴费' || row.application_status == '无需缴费') && row.case_array && row.case_array.length > 0
            
            return hasResourceCenter || hasOfficialCourse || hasCertificate || hasTeamMembers || hasReceipt || hasCaseOperations
        },
        canCancelApplication(row) {
            if (!row || !row.application_status) {
                return false
            }
            if (this.isComboAwaitingPeerPay(row)) {
                return false
            }
            return !['已取消', '已缴费'].includes(row.application_status)
        },
        handleAction(command, row) {
            switch (command) {
                case 'viewExams':
                    this.viewExams(row)
                    break
                case 'viewTimeline':
                    this.viewTimeline(row)
                    break
            }
        },
        handleResourceAction(command, row) {
            if (command === 'resourceCenter') {
                this.gotoResourceCenter(row)
            } else if (command === 'officialCourse') {
                this.gotoClassManageView(row)
            } else if (command === 'certificate') {
                this.gotoAwardView(row)
            } else if (command === 'viewTeamMembers') {
                this.showTeamMembers(row)
            } else if (command === 'receipt') {
                this.downloadInvoice(row)
            } else if (command.startsWith('case-')) {
                const index = parseInt(command.replace('case-', ''))
                const caseItem = row.case_array[index]
                if (caseItem) {
                    if (caseItem.case_button_status === 1 && caseItem.case_material_url) {
                        this.openMaterialLink(caseItem.case_material_url)
                    } else if (caseItem.case_button_status === 0) {
                        this.$message.warning('Not open for viewing yet. Open for Viewing Time: ' + this.formatCaseReleaseTime(caseItem.case_release_time))
                    }
                }
            } else if (command.startsWith('submit-')) {
                this.doShowStudentSubmissionDialog(row)
            }
        },
    }
})
</script>

<style scoped lang="scss">
/deep/ .el-table .custom-row-bg {
    background: #FAE3E4;
}

/deep/ .el-table .custom-head-cell {
    background: var(--c-primary);
    color: white;
    text-align: center;
    border: 1px solid white;
    box-sizing: border-box;
    font-family: Ubuntu-Bold;
}

/deep/ .el-table .cell {
    white-space: normal;
    word-break: keep-all;
    word-wrap: break-word;
}

// /deep/ .el-button {
//   &:not(:first-child) {
//     margin-left: 5px;  /* Element UI's default button margin */
//     margin-right: 5px;
//   }
//   &:first-child {
//     margin-left: 0;
//   }
// }

.operation-item {
    padding: 5px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}
.operation-item:first-child{
    margin-left: 0px;
}
.operation-item:last-child{
    margin-right: 0px;
}
/* Or if you want to remove all margins */
/deep/ .el-button {
    // margin: 0px;
    display: block;
    // margin-bottom: 5px;
}


.custom-time-item {
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.custom-time-policy {
    margin-bottom: 20px;
    padding: 16px 18px;
    background: #f4f4f5;
    border-radius: 4px;
    color: #303133;
}

.custom-time-policy,
.custom-time-reason {
    word-break: normal;
    overflow-wrap: break-word;
    hyphens: none;
}

.custom-time-policy__title,
.custom-time-reason__title {
    margin: 0 0 8px;
    font-weight: 600;
}

.custom-time-policy__list {
    margin: 0 0 10px;
    padding-left: 20px;
    line-height: 1.65;
}

.custom-time-reason {
    margin: 20px 0 0;
    padding: 16px 18px;
    background: #fafafa;
    border-radius: 4px;
}

.custom-time-reason__help {
    margin: 0 0 12px;
    color: #606266;
    font-size: 13px;
    line-height: 1.55;
}
.empty-bottom {
   width: 100%;
   height: 100px;
}

.operations-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.admin-operations {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 4px;
    padding-left: 15px;  /* Add left padding to the container */

    .el-button {
        margin: 0;  /* Override element-ui default margins */
    }
    
    .el-button:first-child {
        margin-left: 0;  /* Ensure first button doesn't have extra margin */
    }
}

/* Category buttons - white background with theme-colored border and font */
.category-button {
    background-color: white !important;
    border-color: #409EFF !important;
    color: #409EFF !important;
}

.category-button:hover {
    background-color: #ecf5ff !important;
    border-color: #66b1ff !important;
    color: #66b1ff !important;
}
</style>
